export default function combineRegex(exps: string[] = []) {
  return new RegExp(`^[${exps.join('')}]*$`);
}
